import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6f05f44f&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f05f44f')) {
      api.createRecord('6f05f44f', component.options)
    } else {
      api.reload('6f05f44f', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6f05f44f&", function () {
      api.rerender('6f05f44f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AoMijUV698hS/JS/imageCarousel.vue"
export default component.exports